import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const typeService = {
    getAllTypes,
    updateTypeStatus,
    getType,
    updateType,
    createType,
};

const MODULE = {
    TYPE: 'rnd-types',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Type') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllTypes(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.TYPE}`, requestOptions)
}


export function updateTypeStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.TYPE}/${data.id}`, requestOptions)
}

export async function getType(id) {
    return await apiHelper(API_URL).get(`/${MODULE.TYPE}/${id}`)
}

export function updateType(data) {
    const requestOptions = {
        name: data.name,
    }
    return apiHelper(API_URL).put(`/${MODULE.TYPE}/${data.id}`, requestOptions)
}

export function createType(data) {
    const requestOptions = {
        name: data.name,
    }

    return apiHelper(API_URL).post(`/${MODULE.TYPE}`, requestOptions)
}